import {Component} from '@angular/core';

@Component({
    selector: 'app-biz-start-up',

    templateUrl: './biz-start-up.component.html',
    styleUrl: './biz-start-up.component.css'
})
export class BizStartUpComponent {

}
